import { imdbEpisodeDetailsDto } from "../../api";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import { Modal } from "@mui/material";

export interface EpisodeProps {
    episodeDetails: imdbEpisodeDetailsDto;
    highestRating: number;
    lowestRating: number;
}

const Episode = ({episodeDetails, highestRating, lowestRating}: EpisodeProps) => {
    const rating = episodeDetails.rating < 10 ? episodeDetails.rating.toFixed(1) : 10;
    const showRating = episodeDetails.rating !== -1;

    const [episodeModalOpen, setEpisodeModalOpen] = useState(false)
    const handleEpisodeModalOpen = () => setEpisodeModalOpen(true);
    const handleEpisodeModalClose = () => setEpisodeModalOpen(false);

    function handleEpisodeClick(e) {
        if(isMobile) {
        //if(isMobile || true) {
            e.preventDefault();
            e.stopPropagation();
            handleEpisodeModalOpen()
        }
        console.log("clicked");
    }

    return (
        <>
        <a
            href={`https://www.imdb.com/title/${episodeDetails.id}/`}
            target="_blank"
            rel="noreferrer"
            className={`${showRating ? "episode" : "episode-no-rating"} ${episodeDetails.rating === highestRating && "highest"} ${episodeDetails.rating === lowestRating && "lowest"}`}
            style={{backgroundPositionY: `${episodeDetails.rating * 200}px`}}
            title={episodeDetails.title}
            onClick={handleEpisodeClick}
        >{showRating && rating}</a>
        <Modal  open={episodeModalOpen} onClose={handleEpisodeModalClose} onClick={handleEpisodeModalClose} >
            <div className="modal-episode">
                <div className="modal-episode-title">Title: {episodeDetails.title}</div>
                <div className="modal-episode-rating">Rating: {showRating ? rating : "unavailable"}</div>
                <div className="modal-episode-link">
                    <a
                        href={`https://www.imdb.com/title/${episodeDetails.id}/`}
                        target="_blank"
                        rel="noreferrer"
                    >View episode on IMDb</a>
                </div>
            </div>
        </Modal>
        </>
    );
}

export default Episode;